import classNames from "classnames";
import React from "react";
import styles from "./Alert.module.scss";

export type AlertVariant = "info" | "success" | "warning" | "error";

type AlertProps = {
  variant?: AlertVariant;
  title?: string;
  children?: React.ReactNode;
  dismissible?: boolean;
  onClose?: () => void;
  className?: string;
};

function Alert({
  variant = "info",
  title,
  children,
  dismissible = false,
  onClose,
  className,
}: AlertProps) {
  return (
    <div className={classNames(styles.alert, styles[variant], className)} role="alert">
      <div className={styles.content}>
        {title && <div className={styles.title}>{title}</div>}
        {children && <div className={styles.message}>{children}</div>}
      </div>
      {dismissible && (
        <button
          type="button"
          className={styles.closeButton}
          aria-label="Dismiss alert"
          onClick={onClose}
        >
          &times;
        </button>
      )}
    </div>
  );
}

export default Alert;
